import { ContentCopy, Delete, ShoppingCartCheckout } from "@mui/icons-material";
import React, { memo, useState } from "react";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

/**
 * Gatilho de gateway de venda.
 *
 * Nao tem entrada: e por aqui que o fluxo comeca quando o gateway avisa que
 * algo aconteceu (carrinho abandonado, Pix gerado, compra aprovada...). O
 * evento e a conexao de envio ficam neste no, entao cada fluxo cuida da sua
 * propria recuperacao.
 */

const NOMES_DE_EVENTO = {
  carrinho_abandonado: "Carrinho abandonado",
  pix_gerado: "Pix gerado (nao pago)",
  boleto_gerado: "Boleto gerado (nao pago)",
  pagamento_atrasado: "Pagamento atrasado",
  compra_aprovada: "Compra aprovada",
  compra_recusada: "Compra recusada",
  reembolso: "Reembolso ou estorno",
  codigo_rastreio: "Codigo de rastreio"
};

const NOMES_DE_GATEWAY = { braip: "Braip" };

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();
  const [sobre, setSobre] = useState(false);

  const d = data || {};
  const gateway = NOMES_DE_GATEWAY[d.gateway] || "Gateway";
  const evento = NOMES_DE_EVENTO[d.evento] || "Escolha o evento";

  return (
    <div
      onMouseEnter={() => setSobre(true)}
      onMouseLeave={() => setSobre(false)}
      style={{
        backgroundColor: "#ffffff",
        padding: "20px",
        borderRadius: "16px",
        minWidth: "250px",
        maxWidth: "250px",
        width: "250px",
        boxSizing: "border-box",
        position: "relative",
        fontFamily: "'Inter', sans-serif",
        border: "2px solid #14b8a6",
        boxShadow: sobre
          ? "0 12px 32px rgba(0,0,0,0.12)"
          : "0 4px 16px rgba(0,0,0,0.06)",
        transition: "all 0.2s cubic-bezier(0.4,0,0.2,1)",
        transform: sobre ? "translateY(-2px)" : "translateY(0px)",
        userSelect: "none"
      }}
    >
      {sobre && (
        <div
          style={{
            position: "absolute",
            top: "-14px",
            right: "8px",
            display: "flex",
            gap: "6px",
            zIndex: 10
          }}
        >
          <ContentCopy
            onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
            style={{
              cursor: "pointer",
              fontSize: "18px",
              color: "#64748b",
              background: "#fff",
              borderRadius: 6,
              padding: 3,
              boxShadow: "0 2px 6px rgba(0,0,0,.15)"
            }}
          />
          <Delete
            onClick={() => {
              storageItems.setNodesStorage(id);
              storageItems.setAct("delete");
            }}
            style={{
              cursor: "pointer",
              fontSize: "18px",
              color: "#ef4444",
              background: "#fff",
              borderRadius: 6,
              padding: 3,
              boxShadow: "0 2px 6px rgba(0,0,0,.15)"
            }}
          />
        </div>
      )}

      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
        <div
          style={{
            width: 34,
            height: 34,
            borderRadius: 10,
            background: "linear-gradient(135deg, #14b8a6, #0f766e)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <ShoppingCartCheckout style={{ color: "#fff", fontSize: 19 }} />
        </div>
        <div style={{ minWidth: 0 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: "#0f172a" }}>
            Recuperação {gateway}
          </div>
          <div style={{ fontSize: 11, color: "#64748b" }}>Início por evento</div>
        </div>
      </div>

      <div
        style={{
          background: d.evento ? "#f0fdfa" : "#fef2f2",
          border: `1px solid ${d.evento ? "#99f6e4" : "#fecaca"}`,
          borderRadius: 8,
          padding: "8px 10px",
          fontSize: 12,
          color: d.evento ? "#0f766e" : "#b91c1c",
          fontWeight: 600
        }}
      >
        {evento}
      </div>

      {!d.whatsappId && (
        <div style={{ fontSize: 10.5, color: "#b91c1c", marginTop: 8 }}>
          Falta escolher por qual conexão responder
        </div>
      )}

      <Handle
        type="source"
        position="right"
        id="a"
        isConnectable={isConnectable}
        style={{
          background: "linear-gradient(135deg, #14b8a6, #0f766e)",
          width: "16px",
          height: "16px",
          right: "-10px",
          border: "2px solid #fff"
        }}
      />
    </div>
  );
});
